import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteRole } from '@services/rbac.service';
import { ROLES_QUERY_KEY } from './useRoles';

export const useDeleteRole = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => deleteRole(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ROLES_QUERY_KEY });
        },
    });
};
